const ContactUs = () => {
  return (
    <div className="contact">
      <h2>Contact:</h2>
      <div className="contact-email">
        <a href="mailto:vietrefugee@gmail.com">vietrefugee@gmail.com</a>
      </div>
    </div>
  );
};

export default ContactUs;
